export const QUALITY_ISSUES_ENDPOINT = 'quality-issues';
export const ISSUES_PERMISSIONS_V1_ENDPOINT = 'permissions';
